import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";
import ChildCareOutlinedIcon from "@mui/icons-material/ChildCareOutlined";
import ChurchOutlinedIcon from "@mui/icons-material/ChurchOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import type { ComponentType } from "react";
import { useTranslation } from "react-i18next";

import { Section, type SectionVariant } from "./Section";

type ServiceKey = "mariage" | "bapteme" | "anniversaire" | "babyshower" | "entreprise" | "custom";

const SERVICE_ICONS: Record<ServiceKey, ComponentType> = {
  mariage: FavoriteBorderOutlinedIcon,
  bapteme: ChurchOutlinedIcon,
  anniversaire: CakeOutlinedIcon,
  babyshower: ChildCareOutlinedIcon,
  entreprise: BusinessCenterOutlinedIcon,
  custom: DesignServicesOutlinedIcon,
};

const SERVICE_KEYS: ServiceKey[] = [
  "mariage",
  "bapteme",
  "anniversaire",
  "babyshower",
  "entreprise",
  "custom",
];

interface ServicesSectionProps {
  variant?: SectionVariant;
}

export function ServicesSection({ variant }: ServicesSectionProps = {}) {
  const { t } = useTranslation(["landing", "common"]);

  return (
    <Section
      id="services"
      variant={variant}
      eyebrow={t("common:eyebrow.services")}
      title={t("landing:services.title")}
      subtitle={t("landing:services.subtitle")}
    >
      <Grid container spacing={3}>
        {SERVICE_KEYS.map((key) => {
          const Icon = SERVICE_ICONS[key];
          return (
            <Grid key={key} size={{ xs: 12, sm: 6, md: 4 }}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 4,
                  transition: "transform 220ms ease, box-shadow 220ms ease",
                  ":hover": { transform: "translateY(-6px)" },
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Stack spacing={2}>
                    <Stack
                      alignItems="center"
                      justifyContent="center"
                      sx={(theme) => ({
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        backgroundColor:
                          theme.palette.mode === "dark"
                            ? "rgba(201,163,90,0.18)"
                            : "rgba(201,163,90,0.14)",
                        color: theme.palette.primary.main,
                      })}
                    >
                      <Icon />
                    </Stack>
                    <Typography variant="h5">{t(`landing:services.items.${key}.title`)}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t(`landing:services.items.${key}.description`)}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Section>
  );
}
